import Confirm from "./confirm";
import BaseModal from "..";

const SecondaryConfirm = {
  show(data) {
    this.self = BaseModal.show({
      borderRadius: 24,
      content: (
        <Confirm
          {...data}
          onClose={this.close}
        />
      ),
      zIndex: 9999,
      wrapClassName: 'nw-base-modal model-task-delete',
      maskClassName: 'nami-work-detail-mask',
      afterClose: () => {
        data?.afterClose?.();
      },
    });
  },
  close() {
    if (this.self) {
      this.self.destroy();
      this.self = null
    }
  }
}

export default SecondaryConfirm